<template>
  <div>
    <div
      id="age-chart"
      class="d-flex"
    >
      <div class="age-title position-relative pr-1">
        AGE
      </div>
      <div
        v-for="(item, index) in data"
        :key="item.age"
        :style="{
          borderColor: colors[index],
          flex: item.size / totalSize,
        }"
        class="age-chart-col d-flex justify-content-center align-items-center pt-1"
      >
        {{ item.age }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      colors: [
        '#2dc3e4',
        '#2aea77',
        '#fbfb21',
        '#ffab14',
        '#ff7516',
      ],
    };
  },
  computed: {
    totalSize() {
      return this.data.reduce((a, c) => a + c.size, 0);
    },
  },
};
</script>
<style scoped>
.age-chart-col {
  font-size: 6px;
  padding: 2px;
  color: black;
  border-top: 3px solid;
}

.age-title {
  font-size: 8px;
  top: -5px;
}
</style>
